export const STATUS_OBJAVE = [
  {
    value: "u proceduri",
    label: "U proceduri",
  },
  {
    value: "usvojen",
    label: "Usvojen",
  },
  {
    value: "završen",
    label: "Završen",
  },
];



export const TYPE_OBJAVE = [
    {
      value: "objave",
      label: "Objave",
    },
    {
      value: "interne_objave",
      label: "Interne objave",
    },
  ];
